/* osery-home — gedrag van de voorpagina, overgenomen uit osery-shop.js van de WP-winkel:
   carrousel die precies één kaart opschuift, tweede foto bij muis-erop, en kleurbolletjes
   die de kaartfoto naar die kleur wisselen. */
(function () {
  var d = document;

  function carrousels(root) {
    root.querySelectorAll('[data-oh-carousel]').forEach(function (sectie) {
      if (sectie.dataset.ohKlaar) { return; }
      sectie.dataset.ohKlaar = '1';
      var spoor = sectie.querySelector('[data-oh-track]');
      var vorige = sectie.querySelector('[data-oh-prev]');
      var volgende = sectie.querySelector('[data-oh-next]');
      if (!spoor) { return; }

      var bijwerken = function () {
        var over = spoor.scrollWidth - spoor.clientWidth;
        var begin = over <= 1 || spoor.scrollLeft <= 1;
        var eind = over <= 1 || spoor.scrollLeft >= over - 1;
        if (vorige) { vorige.style.opacity = begin ? '0.3' : '1'; }
        if (volgende) { volgende.style.opacity = eind ? '0.3' : '1'; }
      };
      var schuif = function (richting) {
        var kaart = spoor.firstElementChild;
        var breedte = kaart ? kaart.getBoundingClientRect().width + 4 : spoor.clientWidth * 0.8;
        spoor.scrollBy({ left: richting * breedte, behavior: 'smooth' });
      };

      if (vorige) { vorige.addEventListener('click', function () { schuif(-1); }); }
      if (volgende) { volgende.addEventListener('click', function () { schuif(1); }); }
      spoor.addEventListener('scroll', bijwerken, { passive: true });
      window.addEventListener('resize', bijwerken);
      bijwerken();
      setTimeout(bijwerken, 500);
      setTimeout(bijwerken, 1500);
    });
  }

  // Kleurfoto's: per product en kleur de twee foto's die WooCommerce op de kaart toonde,
  // herkend aan de hash in de bestandsnaam (die is bij de overzet naar Shopify gelijk gebleven).
  function kleurfotos(kaart) {
    var alle = [];
    try { alle = JSON.parse(kaart.getAttribute('data-oh-media')) || []; } catch (e) { alle = []; }
    var kaartJson = d.getElementById('oh-kleurfotos');
    var map = {};
    try { map = kaartJson ? JSON.parse(kaartJson.textContent) : {}; } catch (e) { map = {}; }
    var perKleur = (map[kaart.getAttribute('data-oh-handle')] || {}).fotos || {};
    var vind = function (hash) {
      for (var i = 0; i < alle.length; i++) { if (alle[i].indexOf(hash) !== -1) { return alle[i]; } }
      return null;
    };
    var uit = {};
    Object.keys(perKleur).forEach(function (kleur) {
      uit[kleur] = perKleur[kleur].map(vind).filter(Boolean);
    });
    return uit;
  }

  // Kleurbolletjes in dezelfde volgorde als op WooCommerce (staat in osery-kleurfotos).
  function volgorde(kaart, stippen) {
    var bron = d.getElementById('oh-kleurfotos');
    var lijst = [];
    try { lijst = ((JSON.parse(bron.textContent) || {})[kaart.getAttribute('data-oh-handle')] || {}).volgorde || []; } catch (e) { lijst = []; }
    if (!lijst.length) { return; }
    var rij = stippen[0].parentNode;
    stippen.slice().sort(function (a, b) {
      var ia = lijst.indexOf(a.getAttribute('data-oh-kleur')), ib = lijst.indexOf(b.getAttribute('data-oh-kleur'));
      return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
    }).forEach(function (s) { rij.appendChild(s); });
  }

  function fotowissel(root) {
    root.querySelectorAll('[data-oh-swap]').forEach(function (kaart) {
      if (kaart.dataset.ohKlaar) { return; }
      kaart.dataset.ohKlaar = '1';
      var eerste = kaart.querySelector('[data-oh-img-1]');
      var tweede = kaart.querySelector('[data-oh-img-2]');
      if (!eerste) { return; }

      var vast = false;
      var toon = function (tweedeAan) {
        if (!tweede) { return; }
        eerste.style.opacity = tweedeAan ? '0' : '1';
        tweede.style.opacity = tweedeAan ? '1' : '0';
      };
      kaart.addEventListener('mouseenter', function () { if (!vast) { toon(true); } });
      kaart.addEventListener('mouseleave', function () { if (!vast) { toon(false); } });

      var wissel = function (e) {
        e.preventDefault();
        e.stopPropagation();
        vast = true;
        toon(tweede && tweede.style.opacity !== '1');
      };
      kaart.querySelectorAll('[data-oh-foto-vorige], [data-oh-foto-volgende]').forEach(function (k) {
        k.addEventListener('click', wissel);
      });

      var stippen = [].slice.call(kaart.querySelectorAll('[data-oh-kleur]'));
      if (!stippen.length) { return; }
      volgorde(kaart, stippen);
      var sets = kleurfotos(kaart);
      var standaard = [eerste.getAttribute('src'), tweede ? tweede.getAttribute('src') : null];
      var gekozen = null;
      var links = [].slice.call(kaart.querySelectorAll('a[data-oh-basis]'));

      var linksNaar = function (variant) {
        links.forEach(function (a) {
          var basis = a.getAttribute('data-oh-basis');
          a.setAttribute('href', variant ? basis + '?variant=' + variant : basis);
        });
      };
      var zet = function (bronnen) {
        eerste.removeAttribute('srcset');
        eerste.src = bronnen[0] || standaard[0];
        if (tweede) {
          tweede.removeAttribute('srcset');
          tweede.src = bronnen[1] || bronnen[0] || standaard[1];
        }
      };

      stippen.forEach(function (stip) {
        stip.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var kleur = stip.getAttribute('data-oh-kleur');
          if (gekozen === kleur) {
            gekozen = null;
            zet(standaard);
            linksNaar(null);
          } else {
            gekozen = kleur;
            var set = sets[kleur] && sets[kleur].length ? sets[kleur] : [];
            if (!set.length && stip.getAttribute('data-oh-foto')) { set = [stip.getAttribute('data-oh-foto')]; }
            zet(set.length ? set : standaard);
            linksNaar(stip.getAttribute('data-oh-variant'));
          }
          stippen.forEach(function (x) { x.classList.toggle('is-gekozen', x === stip && gekozen !== null); });
          vast = true;
          toon(false);
        });
      });
    });
  }

  function start(root) { carrousels(root || d); fotowissel(root || d); }
  if (d.readyState === 'loading') { d.addEventListener('DOMContentLoaded', function () { start(); }); } else { start(); }
  // Thema-editor: secties worden los opnieuw geladen
  d.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();
